module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/day02_03_stay-8835c216267af65d4f56533c6995db9a.jpg";